
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const { t } = useLanguage();
  
  // Add translations for 404 pages
  const notFoundText = {
    fr: "Oups ! La page que vous recherchez n'existe pas.",
    en: "Oops! The page you are looking for does not exist.",
    es: "¡Ups! La página que buscas no existe.",
    it: "Ops! La pagina che stai cercando non esiste.",
    de: "Hoppla! Die gesuchte Seite existiert nicht.",
    nl: "Oeps! De pagina die u zoekt bestaat niet.",
  };
  
  const backToHome = {
    fr: "Retour à l'accueil",
    en: "Back to home",
    es: "Volver al inicio",
    it: "Torna alla home",
    de: "Zurück zur Startseite",
    nl: "Terug naar home",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-villa-sand/30">
      <div className="text-center p-8 max-w-md">
        <h1 className="text-6xl font-playfair font-bold text-villa-blue mb-4">404</h1>
        <p className="text-2xl text-villa-blue mb-8">
          {notFoundText[t('language') as keyof typeof notFoundText]}
        </p>
        <Button asChild className="bg-villa-turquoise hover:bg-opacity-90">
          <Link to="/">{backToHome[t('language') as keyof typeof backToHome]}</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
